import React, { FC } from 'react'
import moment from 'moment'
import { FormattedDateTime } from 'transfix-ui/components/FormattedDateTime'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Box } from 'transfix-ui/core'
import { FORMATS } from 'constants/datetime'
import ControlledDateTimeInput from '../ControlledDateTimeInput'
import InlineEditDisplay from './InlineEditDisplay'
import { TOnSubmitField } from './types'

interface ISelectDueDateProps {
  value?: string | null
  onChange: TOnSubmitField
  readOnly?: boolean
}

const PastDue = () => {
  return (
    <Box ml={2}>
      <InlineMessage message='Past Due' type={INLINE_MESSAGE_VARIANTS.WARNING} />
    </Box>
  )
}

/**
 * Due date entry with calendar + time inputs
 */
export const SelectDueDate: FC<ISelectDueDateProps> = ({ onChange, readOnly, value }) => {
  const isPastDue = value ? moment(value).isBefore() : false

  return (
    <InlineEditDisplay
      name='dueAt'
      dataTest='date-edit'
      label='Due'
      onSubmit={onChange}
      readOnly={readOnly}
      displayValue={
        <>
          {value ? (
            <Box display='flex' alignItems='center'>
              <FormattedDateTime
                inSentence
                showTimezone
                datetime={value}
                format='timeDateAndYear'
                displayTimezone={FORMATS.defaultTimeZone}
              />
              {isPastDue && <PastDue />}
            </Box>
          ) : (
            '--'
          )}
        </>
      }>
      <Box display='flex' alignItems='flex-end'>
        <ControlledDateTimeInput defaultValue={value} />
        {isPastDue && <PastDue />}
      </Box>
    </InlineEditDisplay>
  )
}

export default SelectDueDate
